import React, {Component} from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { ReactComponent as GVectorIcon }  from '@apgm/assets/svg/g_Vector.svg'
import { ReactComponent as LogoShopee } from '@apgm/assets/svg/shopee_white.svg'
import { ReactComponent as LeftTriangleIcon } from '@apgm/assets/svg/left_triangle.svg'
import { $t } from '@/modules/i18n';

class PhotoGallery extends Component {
  constructor(props) {
    super(props);
  }

  jump(url) {
    if (url) {
      window.location.href(url);
    }
    return true;
  }
  _renderVideo(item) {
    return (
      <div className='image-gallery-image'>
        {
            <div className="gallery-container" onClick={this.jump.bind(this, item.embedUrl)}>
              <div className="left-gallery-banner">
                <img src={item.original}/>
                <LeftTriangleIcon className="left-triangle-icon" />
              </div>
              {
                item.description && Object.keys(item.description).length &&
                  <div
                    className='gallery-right-description'
                  >
                    <GVectorIcon className="vertor-icon" />
                    <div className="logon-icon-wrapper">
                      {/* <LogoShopee className="logo-icon" /> */}
                      <div className="info-content">
                        <p className="top-desc">{$t(item.description.introduction)}<span> </span> </p>
                      </div>
                    </div>
                    <div className="info-content">
                      <div className="desc-bottom-wrapper">
                        <div className="tit">{$t(item.description.info.title)}</div>
                        <div className="desc">{$t(item.description.info.profession)}</div>
                        <div className="end">{$t(item.description.info.country)}</div>
                      </div>
                    </div>
                  </div>
              }
            </div>
        }
      </div>
    );
}

  render() {
    const { items, ...others } = this.props;
    const images = Object.keys(this.props.images).map((keyName, keyIndex) => {
      return {...this.props.images[keyName], renderItem: this._renderVideo.bind(this)};
    });
    return (
      <ImageGallery { ...others } items={images} additionalClass="c-image-gallery" />
    )
  }
}

export default PhotoGallery;